/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { SVGProps } from 'react';

export const CheckmarkCircleAlternate = (props: SVGProps<SVGSVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      id="Shape - Checkmark-Circle"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 9C0 13.9626 4.0374 18 9 18C13.9626 18 18 13.9626 18 9C18 4.0374 13.9626 0 9 0C4.0374 0 0 4.0374 0 9ZM1.8 9C1.8 5.0301 5.0301 1.8 9 1.8C12.9699 1.8 16.2 5.0301 16.2 9C16.2 12.9699 12.9699 16.2 9 16.2C5.0301 16.2 1.8 12.9699 1.8 9ZM4.60431 9.79657L8.24301 13.4353L13.5152 6.05437L11.6837 4.74667L7.95591 9.96577L6.19461 8.20537L4.60431 9.79657Z"
      fill="currentColor"
    />
  </svg>
);
